module.exports = __webpack_public_path__ + "media/images/resource/ezcaterxeatokra-2408f772db9f994aa9b619c58f1cdf2c.png";